<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <QuestionBase>
    <template v-slot:question>
      <slot name="question">{{ updatedQuestion }}</slot>
    </template>
    <template v-slot:question-options>
      <div ref="npsClientArea"> 
        <Slider v-if="vertical">
          
          
        </Slider>
        <div
        v-if="!vertical"
          class="lgrm-nps-buttons"
          ref="npsButtons"
          v-resize-sensor="onResize"
          :class="{ 'lgrm-vertical': vertical }"
        >
          <button
            class="lgrm-nps-button"
            :class="[
              'lgrm-' + buttonShape.toLocaleLowerCase(),
              { 'lgrm-selected': selectedValue === i }
            ]"
            :style="lgrmNpsButtonStyle"
            v-for="i in ranges"
            :key="i"
            @click="npsButtonClick(i)"
            ref="npsbuttons"
          >
            <div :style="getButtonBorderStyle(i)" class="nps-button-value">
              {{ i }}
              <span class="lgrm-nps-label lgrm-low" v-if="i === 0">{{
                minLabel
              }}</span>
              <span class="lgrm-nps-label lgrm-high" v-if="i === 10">{{
                maxLabel
              }}</span>
            </div>
            <div :style="getButtonBgStyle(i)" class="nps-button-bg"></div>
          </button></div
      >
    </div>
    </template>
  </QuestionBase>
</template>

<script>

import range from 'lodash/range'
import strings from '../../../../src/strings'
import colorMixin from '../../../../src/mixins/colors'
import QuestionBase from './QuestionBase'
import Slider from './range_slider/RangeSlider.vue'
export default {
  name: 'NpsQuestion',
  mixins: [colorMixin],
  components: {
    QuestionBase,
    Slider
  },
  props: {
    question: {
      type: String,
      default:
        'How likely would you recommend {brand_name} to a friend or colleague?'
    },
    brandName: String,
    value: { type: Number, default: -1 },
    minLabel: {
      type: String,
      default: strings.NPS.widget_button_labels.not_likely
    },
    maxLabel: {
      type: String,
      default: strings.NPS.widget_button_labels.likely
    },
    buttonShape: { type: String, default: 'SQUARE' }, // CIRCLE, SQUARE,
    color: { type: String, default: '#132968' },
    borderColor: { type: String },
    minValue: { type: Number, default: 0 },
    maxValue: { type: Number, default: 10 }, //inclusive,
    npsButtonLabelColor: { type: String, default: null },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 40
    },
    animationEnabled: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      selectedValue: this.value,
      vertical: false
    }
  },
  mounted(){
    console.log(this.$refs.npsbuttons)
    if(this.animationEnabled)
      this.$anime({
        targets: this.$refs.npsbuttons,
        direction: 'alternate',
        loop: false,
        easing: 'spring(1, 80, 10, 0)',
        delay: this.$anime.stagger(80),
        keyframes: [
          {translateY: -10},
          {translateY: 0},
        ],
      });
    
  },
  computed: {
    updatedQuestion: function() {
      if (this.brandName)
        return this.question.replace('{brand_name}', this.brandName)
      return this.question
    },
    ranges: function() {
      let ranges = range(this.minValue, this.maxValue + 1)
      if (this.vertical) {
        ranges.reverse()
      }
      return ranges
    },
    lgrmNpsButtonStyle: function(){
      if(this.vertical){
        return {}
      }
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        lineHeight: this.size + 'px'
      }
    } 
  },
  methods: {
    getButtonBorderStyle(value) {
      const stl = {}
      stl.border = '1px solid ' + (this.borderColor || this.color)
      stl.color = '#000'
      if (value === this.selectedValue) {
        stl.border = '1px solid ' + this.color
          if (this.isColorLighter(this.color)) {
          stl.color = '#000'
        } else {
          stl.color = '#fff'
        }
      }
      else{
        if (this.npsButtonLabelColor) {
          stl.color = this.npsButtonLabelColor
        }
      }
      return stl
    },
    getButtonBgStyle(value) {
      const stl = {}
      stl.border = '1px solid ' + this.color
      stl.color = this.color
      stl.background = this.color
      if (value === this.selectedValue) {
        stl.background = this.color
        if (this.npsButtonLabelColor) {
          stl.color = this.npsButtonLabelColor
        } else if (this.isColorLighter(this.color)
        ) {
          stl.color = '#000'
        } else {
          stl.color = '#fff'
        }
      }
      return stl
    },
    onResize: function() {
      const vm = this
      vm.vertical = vm.$refs.npsClientArea.clientWidth < 400
    },
    npsButtonClick(value) {
      if (this.readonly) return
      this.selectedValue = value
      this.$emit('change', value)
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="stylus" scoped>

.lgrm-nps-buttons {
    padding-bottom: 25px;
    .lgrm-nps-button {
        width 40px
        height 40px
        box-sizing: border-box;
        margin: 3px
        outline none
        position relative
        color: $color-primary
        transition: border-radius .5s ease;
        cursor pointer
        font-size 14px
        background #fff
        border none
        /*transition-property color, border*/
        .nps-button-value {
            width 100%
            height 100%
            position absolute
            top:0
            z-index 2
            transition: border-radius  .5s ease;
        }
        .nps-button-bg {
            width 100%
            height 100%
            opacity .05
            position absolute
            top:0
            z-index 1
            transition: border-radius  .5s ease;
        }
        &.lgrm-square {
            border-radius: 3px;
            .nps-button-value, .nps-button-bg {
                border-radius: 3px;
            }
        }
        &.lgrm-circle {
            border-radius 20px
            .nps-button-value, .nps-button-bg {
                border-radius 20px
            }
        }
        .lgrm-nps-label {
            font-size 12px
            font-weight normal
            color: #666666
            position absolute
            min-width 100px
            bottom -35px
            &.lgrm-low {
                left: 0
                text-align left
            }
            &.lgrm-high {
                right: 0
                text-align right
            }
        }
        &.lgrm-selected {
            font-weight 500
            color: #fff
            .nps-button-bg {
                opacity 1
            }
            .lgrm-nps-label {
                font-weight normal
            }
        }
    }

    &.lgrm-vertical {
        .lgrm-nps-label {
            position relative
            bottom auto
        }
        .lgrm-nps-button {
            display block
            margin 3px auto
            width 70%
            line-height 35px
        }
        .lgrm-selected {
            font-weight 500
            color: #fff
            .nps-button-bg {
                opacity 1
            }
            .lgrm-nps-label {
                color: #fff
                font-weight normal
            }
        }
    }
}
</style>
